import { DefaultLayout } from '@layouts';
import { NextSeo } from 'next-seo';
import { Section, Hero, IntroMarkup, LazyImage } from '@components';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { stringify } from 'qs';
import { useMediaQueries, useStrapiImageFormat } from '@hooks';
import { useRef } from 'react';
import classnames from 'classnames';

export default function PhilosophyPage({ data }) {
  const { hero, introduction, seo, gallery } = data;
  const sliderRef = useRef(null);
  const { isMobile } = useMediaQueries();
  return (
    <>
      <NextSeo
        title={`Momento | ${seo?.metaTitle}`}
        description={seo?.metaDescription}
      />
      <DefaultLayout
        showBookingCta={false}
        className="pb-20 mb-0"
        header={
          <Hero
            cta={null}
            isHero
            hasSlider={false}
            label={hero?.label}
            title={hero?.title}
            description={hero?.description}
            img={hero?.media?.data?.[0]?.attributes}
          />
        }
      >
        <Section className={'mb-0  pt-10 md:pt-0 pb-0'}>
          <IntroMarkup
            text={introduction}
            className={'md:columns-2'}
          />

          <Splide
            tag="section"
            ref={sliderRef}
            options={{
              drag: true,
              type: 'slide',
              width: '100%',
              height: '100%',
              autoplay: true,
              pagination: isMobile,
              arrows: false,
              padding: 0,
              rewind: true,
              snap: true,
              perPage: isMobile ? 1 : 3,
              perMove: isMobile ? 1 : 3,
              focus: 0,
              flickPower: 800,
              flickMaxPages: 1,
              lazyLoad: 'nearby',
              video: {
                loop: true,
                mute: true,
              },
            }}
          >
            {gallery?.data?.length > 0 &&
              gallery?.data?.map(({ attributes }, i) => {
                return (
                  <SplideSlide
                    key={i}
                    className={classnames(
                      'relative',
                      'z-10 rounded-t-sm md:rounded-sm',
                      'h-[45vh] md:h-[30vh] md:max-h-[35vw] lg:h-[80vh]',
                      'centered',
                    )}
                  >
                    <LazyImage
                      img={useStrapiImageFormat({
                        img: attributes,
                      })}
                      alt="img"
                      skeletonCls="absolute left-0 top-0 right-0 bottom-0"
                      className={classnames(
                        'object-cover object-center w-full h-[45vh] md:h-[30vh] lg:h-[80vh] -z-10  rounded-t-sm md:rounded-sm',
                      )}
                    />
                  </SplideSlide>
                );
              })}
          </Splide>
        </Section>
      </DefaultLayout>
    </>
  );
}

export async function getServerSideProps({ res, locale }) {
  /*  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59',
  ); */

  const path = process.env.NEXT_PUBLIC_STRAPI; // process.env.NEXT_PUBLIC_STRAPI;
  const lang = `locale=${locale}`;

  const populatePhilosophyPage = stringify(
    {
      populate: ['hero', 'hero.media', 'seo', 'gallery'],
    },
    { encodeValuesOnly: true },
  );

  // PhilosophyPage Data
  const getPhilosophyPage = await fetch(
    `${path}/philosophy-page?populate=${populatePhilosophyPage}&${lang}`,
  );
  const philosophyPage = await getPhilosophyPage?.json();

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      data: philosophyPage?.data?.attributes || {},
    },
  };
}
